import { render, staticRenderFns } from "./GridCard.vue?vue&type=template&id=22c3cd76&"
import script from "./GridCard.vue?vue&type=script&lang=js&"
export * from "./GridCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports